import { useMutation } from '@tanstack/react-query';
import { useRef } from 'react';

import { notifyMeta } from '@/lib/notify';
import { authService } from '@/services/auth';
import { errorUtils } from '@/services/errors';

type TPasswordRecoveryPayload = {
  tokenHash: string;
  password: string;
  code: string;
};

const CODE_REQUIRED = 'mfa_code_required';

const useUpdatePassword = () => {
  const isRecoveredRef = useRef(false);

  return useMutation<void, Error, TPasswordRecoveryPayload>({
    meta: notifyMeta('authPasswordUpdate'),
    mutationFn: async ({ tokenHash, password, code }) => {
      if (!isRecoveredRef.current) {
        errorUtils.unwrap(await authService.verifyRecovery(tokenHash));
        isRecoveredRef.current = true;
      }

      const factorID = errorUtils.unwrap(await authService.readVerifiedFactorID());

      if (factorID && !code) {
        throw errorUtils.toThrowable(errorUtils.createNetworkError(CODE_REQUIRED, undefined, 'useUpdatePassword'));
      }

      if (factorID) {
        errorUtils.unwrap(await authService.verifyTotp(factorID, code));
      }

      errorUtils.unwrap(await authService.updatePassword(password));
    },
  });
};

export type {
  TPasswordRecoveryPayload,
};
export {
  useUpdatePassword,
};
